import React from 'react';

export default ({ text, altClass='' }) => {
    return (
        <>
            <div className={`loading-container${altClass}`}>
                <span /><span /><span />
            </div>
            <div className='text-center'><p>{text}</p></div>
        </>
    )
}